<template>
    <li class="d-block my">
        <div class="d-inline-flex flex-align-center cursor-pointer">
            <div
                class="bg-white rounded-full"
                style="width: 0.5rem; height: 0.5rem"
                :style="{
                    transform: `scale(${isActive ? 2 : 1})`,
                    transition: `transform ${animationDuration}ms ease-in-out`,
                }"
            ></div>
            <div
                style="transform-origin: 0 50% 0; margin-left: 2.5rem"
                :style="{
                    opacity: showTitle ? 1 : 0,
                    transform: `scale(${isActive ? 1.5 : 1})`,
                    transition: `opacity ${animationDuration}ms ease-in-out, transform ${animationDuration}ms ease-in-out`,
                }"
            >
                {{ title }}
            </div>
        </div>
    </li>
</template>

<script>
    export default {
        name: 'BrandBookSideBarItem',
        props: {
            title: {
                type: String,
                required: true,
            },
            showTitle: {
                type: Boolean,
                required: true,
            },
            isActive: {
                type: Boolean,
                required: true,
            },
        },

        data() {
            return {
                animationDuration: 750,
            };
        },
    };
</script>
